import React, { useState, useRef, useEffect } from "react";
import "./PosCustomTimeSelector.css";
import PosCustomIcon from "../PosCustomIcon/PosCustomIcon";
import { ClockIcon } from "@heroicons/react/24/outline";
import { XMarkIcon } from "@heroicons/react/20/solid";

const hours = Array.from({ length: 12 }, (_, i) => i + 1);
const minutes = Array.from({ length: 60 }, (_, i) => i.toString().padStart(2, "0"));

const PosCustomTimeSelector = ({
  value,
  onChange,
  dropdownPosition = "bottom",
  width = "100%",
  padding = "4px 4px",
  radius = "6px",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedHour, setSelectedHour] = useState(null);
  const [selectedMinute, setSelectedMinute] = useState(null);
  const [selectedPeriod, setSelectedPeriod] = useState(null);

  const wrapperRef = useRef();

  // Close dropdown on outside click
  useEffect(() => {
    function handleClickOutside(e) {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Update parent when all selected
  useEffect(() => {
    if (selectedHour && selectedMinute && selectedPeriod) {
      const formatted = `${selectedHour
        .toString()
        .padStart(2, "0")}:${selectedMinute} ${selectedPeriod}`;
      onChange(formatted);
      setIsOpen(false);
    }
  }, [selectedHour, selectedMinute, selectedPeriod]);

  // Clear Time
  const handleClear = (e) => {
    e.stopPropagation(); // prevent dropdown opening
    setSelectedHour(null);
    setSelectedMinute(null);
    setSelectedPeriod(null);
    onChange(null);
  };

  return (
    <div className="time-picker-wrapper" ref={wrapperRef} style={{ width: width }}>
      <div
        className="time-input"
        onClick={() => setIsOpen((prev) => !prev)}
        style={{ padding: padding, borderRadius: radius }}
      >
        {value || "HH : MM : AM/PM"}
        <PosCustomIcon
          icon={value ? <XMarkIcon /> : <ClockIcon />}
          height={"16px"}
          width={"16px"}
          color="#333333"
          pointer={!!value}
          onClickFunction={value ? handleClear : undefined}
        />
      </div>

      {isOpen && (
        <div className={`timeDropdown ${dropdownPosition}`}>
          {/* Hours */}
          <div className="timeColumn">
            {hours.map((h) => (
              <div
                key={h}
                className={`item ${selectedHour === h ? "active" : ""}`}
                onClick={() => setSelectedHour(h)}
              >
                {h}
              </div>
            ))}
          </div>

          {/* Minutes */}
          <div className="timeColumn">
            {minutes.map((m) => (
              <div
                key={m}
                className={`item ${selectedMinute === m ? "active" : ""}`}
                onClick={() => setSelectedMinute(m)}
              >
                {m}
              </div>
            ))}
          </div>

          {/* AM / PM */}
          <div className="timeColumn">
            {["AM", "PM"].map((p) => (
              <div
                key={p}
                className={`item ${selectedPeriod === p ? "active" : ""}`}
                onClick={() => setSelectedPeriod(p)}
              >
                {p}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default PosCustomTimeSelector;
